export default "__VITE_ASSET__DXLlGZJY__"